import { render, staticRenderFns } from "./ToolBox.vue?vue&type=template&id=3af04aaf&"
import script from "./ToolBox.vue?vue&type=script&lang=js&"
export * from "./ToolBox.vue?vue&type=script&lang=js&"
import style0 from "./ToolBox.vue?vue&type=style&index=0&id=3af04aaf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports